import React, { useEffect, useState } from "react";
import axios from "../../utils/AxiosInstance";
import { Table, Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

const RoleManagement = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const permissionLabels = {
    0: "View",
    1: "Create",
    2: "Update",
    3: "Delete",
    4: "Full",
  };

  const getPermissionNames = (codes = []) =>
    codes.map((code) => permissionLabels[code]).join(", ");

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/super/role/get");
      console.log(res);
      if (res.status === 200) {
        setRoles(res.data.data);
        toast.success(res.data.message);
      }
    } catch (err) {
      toast.error("Failed to fetch roles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className="container mt-4">
      <ToastContainer />
      <h4>All Roles</h4>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Role Name</th>
              <th>User</th>
              <th>Booking</th>
              <th>Car</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {roles.length > 0 ? (
              roles.map((role, idx) => (
                <tr key={role._id}>
                  <td>{idx + 1}</td>
                  <td>{role.name}</td>

                  <td>{getPermissionNames(role.permissions?.user)}</td>
                  <td>{getPermissionNames(role.permissions?.booking)}</td>

                  <td>{getPermissionNames(role.permissions?.car)}</td>
                  <td>{getPermissionNames(role.permissions?.category)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No roles found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};
export default RoleManagement;
